import { createApiClient, responseData } from '#lib/api/client.js';

export const getNewsArticleSearch = async (
	fetchFn: typeof globalThis.fetch,
	query: { phrase: string; limit: number; page: number }
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/news-article-search',
			{
				params: { query },
			}
		)
	);
